import NovalueCheck from './NoValueCheck';

export default (value, age, gender) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  // ค่าปกติกรดยูริค:
  // ผู้ชาย (gender = 1): 3.4-7.0 mg/dL
  // ผู้หญิง (gender = 0): 2.4-6.0 mg/dL
  const isMale = gender === 1 || gender === '1' || gender === 'M' || gender === 'male';
  const maxNormal = isMale ? 7.2 : 6.0;
  const minNormal = isMale ? 3.5 : 2.6;

  if(value >= minNormal && value <= maxNormal) {
    return {
      title: 'ยูริคในเลือดปกติ',
      color: 'green',
      caption: 'ยูริคในเลือดปกติ',
      suggest: ''
    };
  } else if(value < minNormal) {
    return {
      title: 'ยูริคในเลือดต่ำ',
      color: 'red',
      caption: 'ยูริคในเลือดต่ำกว่าปกติ',
      suggest: 'ควรปรึกษาแพทย์'
    };
  } else {
    return {
      title: 'ยูริคในเลือดสูงกว่าปกติ',
      color: 'red',
      caption: 'ยูริคในเลือดสูงกว่าปกติ',
      suggest: 'ปรับพฤติกรรม พบนักโภชนาการ หรือ นักกำหนดอาหาร'
    };
  }

}